import styled from "styled-components";

export const StyledUnitMembersContainer = styled.div`
	& > button {
		margin-top: 5rem;
		margin-right: 2rem;
	}

	& > div {
		margin-bottom: 2rem;
	}
`;

export const StyledUnitMembersHeader = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;

	& > div {
		width: 26rem;
		margin-bottom: 0;
	}

	& form {
		width: 40rem;
	}
`;

export const StyledUnitMembersList = styled.div`
	margin-top: 1.6rem;
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-auto-rows: auto;
	column-gap: 1.6rem;
	row-gap: 1.2rem;

	@media screen and (min-width: 1600px) {
		grid-template-columns: repeat(6, 1fr);
	}

	@media screen and (min-width: 2000px) {
		grid-template-columns: repeat(7, 1fr);
	}
`;
